// ** Vertical Menu Components
import VerticalNavMenuLink from "./VerticalNavMenuLink";
import VerticalNavMenuGroup from "./VerticalNavMenuGroup";
import VerticalNavMenuSectionHeader from "./VerticalNavMenuSectionHeader";
import classnames from "classnames";
import { useHistory } from "react-router-dom";
// ** Utils
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from "@layouts/utils";
import { handleLogout } from "../../../../../redux/authentication";
import { useSelector, useDispatch } from "react-redux";
import {
    handleTour,
    handleShowTour,
    handleStartVideo,
} from "../../../../../redux/layout";

const VerticalMenuNavItems = (props) => {
    const history = useHistory();
    const tour = useSelector((state) => state.layout.tour);
    // ** Components Object
    const Components = {
        VerticalNavMenuLink,
        VerticalNavMenuGroup,
        VerticalNavMenuSectionHeader,
    };
    const dispatch = useDispatch();

    const handleItemClick = () => {
        dispatch(handleLogout());
        history.push("login");
    };

    const handleItemClickTour = () => {
        const currentPathname = window.location.pathname;

        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key.includes(`tour-${currentPathname}`)) {
                localStorage.removeItem(key);
            }
        }
        dispatch(handleStartVideo(true));
        if (tour) {
            dispatch(handleTour(false));
        } else {
            dispatch(handleTour(true));
        }
    };

    const RenderNavItems = props.items
        .map((item, index) => {
            const TagName = Components[resolveNavItemComponent(item)];

            if (props.role === "student") {
                if (item.id === "courses") {
                    if (props.isInvate === false) {
                        return null;
                    }
                }
            }
            if (props.role === "instructor") {
                if (item.id != "courses") {
                    return null;
                }
            }

            if (item.id === "logout") {
                return (
                    <li key={"xcv434"} className={classnames("nav-item")}>
                        <a
                            className="d-flex align-items-center"
                            onClick={handleItemClick}
                        >
                            {item.icon}
                            <span className="menu-item text-truncate leftBarMenu">
                                {item.title}
                            </span>
                        </a>
                    </li>
                );
            }

            if (item.id === "replayTour") {
                return (
                    <li key={"xcv4d34"} className={classnames("nav-item")}>
                        <a
                            className="d-flex align-items-center"
                            onClick={handleItemClickTour}
                        >
                            {item.icon}
                            <span className="menu-item text-truncate leftBarMenu">
                                {item.title}
                            </span>
                        </a>
                    </li>
                );
            }

            if (item.children) {
                return (
                    <TagName
                        item={item}
                        index={index}
                        key={item.id}
                        {...props}
                    />
                );
            }

            return (
                <TagName key={item.id || item.header} item={item} {...props} />
            );
        })
        .filter((item) => item !== null);
    return RenderNavItems;
};

export default VerticalMenuNavItems;
